import { EUserRoles } from "@models/user";

export const LOGOUT_FORM = {
  LOGOUT_FORM_TITLE: "MENTEX",
  LOGOUT_BTN: "ログアウト",
  LOGOUT_MODAL_TITLE: "確認",
  LOGOUT_MODAL_OK: "ログアウト",
  LOGOUT_MODAL_CANCEL: "キャンセル",
  LOGOUT_MODAL_MSG: "ログアウトしてもよろしいでしょうか？",
};

export const USER_ROLE_DISPLAY_NAME: Record<EUserRoles, string> = {
  [EUserRoles.ADMIN]: "経理部",
  [EUserRoles.STORE_OWNER]: "各店舗",
};
